import { ArrowBack } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsDesktop } from '../../../hooks/use-is-desktop';
import { useIsMobile } from '../../../hooks/use-is-mobile';

const DRAWER_WIDTH = 260;

interface WizardNavigationProps {
  canGoBack: boolean;
  canGoNext: boolean;
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  isLoading?: boolean;
}

export function WizardNavigation({
  canGoBack,
  canGoNext,
  onBack,
  onNext,
  nextLabel,
  isLoading = false,
}: WizardNavigationProps) {
  const { t } = useTranslation('goodsReceiving');
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: isDesktop ? DRAWER_WIDTH : 0,
        right: 0,
        p: 2,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        display: 'flex',
        gap: 2,
        justifyContent: isDesktop ? 'flex-end' : 'stretch',
        zIndex: 1000,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
      }}
    >
      {canGoBack && (
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={isLoading}
          startIcon={<ArrowBack />}
          sx={{
            flex: isMobile ? 1 : 'none',
            minWidth: isDesktop ? 120 : 'auto',
          }}
        >
          {t('wizardBack')}
        </Button>
      )}
      <Button
        variant="contained"
        onClick={onNext}
        disabled={!canGoNext || isLoading}
        fullWidth={isMobile && !canGoBack}
        sx={{
          flex: isMobile && canGoBack ? 1 : 'none',
          minWidth: isDesktop ? 120 : 'auto',
        }}
      >
        {nextLabel ?? t('wizardNext')}
      </Button>
    </Box>
  );
}
